document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.card-carousel');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('.card-carousel-track');
    const dots = carousel.querySelectorAll('.card-carousel-dot');
    if (!track || dots.length < 2) return;

    let isDown = false;

    // Evita que el swipe dispare el link de la tarjeta (navegación al producto)
    track.addEventListener('touchstart', () => { isDown = false; }, { passive: true });
    track.addEventListener('touchmove', () => { isDown = true; }, { passive: true });
    track.addEventListener('click', (e) => {
      if (isDown) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      // Tap sin deslizar: ahora el carrusel está por encima del link invisible
      // de Dawn, así que navegamos nosotros mismos al producto.
      const url = carousel.dataset.productUrl;
      if (url) {
        window.location.href = url;
      }
    }, true);

    const updateActiveDot = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateActiveDot);
    }, { passive: true });
  });
});